import Vue from "vue";
import Component from 'vue-class-component';

enum Status {
    Initial,
    Invoking,
    Succeed,
    Invalid,
    Failed
}

@Component
export default class PageStatus extends Vue {
    status: Status = Status.Initial;

    get statusInitial() { return this.status == Status.Initial }
    get statusInvoking() { return this.status == Status.Invoking }
    get statusSucceed() { return this.status == Status.Succeed }
    get statusInvalid() { return this.status == Status.Invalid }
    get statusFailed() { return this.status == Status.Failed }

    setStatusInitial() { return this.status = Status.Initial }
    setStatusInvoking() { return this.status = Status.Invoking }
    setStatusSucceed() { return this.status = Status.Succeed }
    setStatusInvalid() { return this.status = Status.Invalid }
    setStatusFailed() { return this.status = Status.Failed }
}